export { SpaCategoryDetailTemplate } from './SpaCategoryDetailTemplate';
export type { SpaCategoryDetailTemplateProps } from './SpaCategoryDetailTemplate.types';
